type StorageValue = string | number | Record<string, any>;

/**
 * localStorage.setItem
 * @param key
 * @param value string | Record<string, any>
 */
export function saveItem(key: string, value: StorageValue) {
  if (!key) return;
  let v = value || (value === 0 ? '0' : '');
  v = typeof value === 'string' ? value : JSON.stringify(value);
  localStorage.setItem(key, v);
}

/**
 * localStorage.getItem
 * @desc 如果可以被JSON解析，则返回解析后的结果
 * @param key
 */
export function getItem(key: string): StorageValue {
  if (!key) return '';
  let v: StorageValue = localStorage.getItem(key) || '';
  try {
    v = JSON.parse(v);
  } catch (e) {
    // eslint-disable-next-line no-empty
  }
  return v;
}

export function removeItem(key: string) {
  localStorage.removeItem(key);
}
